'use strict';

import {
	UPDATE_INGREDIENT_CONFIGURATION_INGREDIENT,
	RESET_INGREDIENT_CONFIGURATION_INGREDIENT,
	SET_INGREDIENT_CONFIGURATION_INGREDIENT,
	UPDATE_BATCH_FORM,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
} from './ingredientConfigurationIngredients.actions';

const defaultState = {
	data: {
		ingredientConfigurationIngredient: {},
		batchFormData: {},
		batchListData: [],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_INGREDIENT_CONFIGURATION_INGREDIENT: {
			return {
				...state,
				data: {
					...state.data,
					ingredientConfigurationIngredient: payload,
				},
			};
		}

		case UPDATE_INGREDIENT_CONFIGURATION_INGREDIENT: {
			return {
				...state,
				data: {
					...state.data,
					ingredientConfigurationIngredient: {
						...state.data.ingredientConfigurationIngredient,
						...payload,
					},
				},
			};
		}

		case UPDATE_BATCH_FORM: {
			return {
				...state,
				data: {
					...state.data,
					batchFormData: {
						...state.data.batchFormData,
						...payload,
					},
				},
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchListData: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchListData: state.data.batchListData.map((entry) => {
						if (entry.identifier === payload.identifier)
							return { ...entry, ...payload };
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchListData: state.data.batchListData.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case RESET_INGREDIENT_CONFIGURATION_INGREDIENT: {
			return defaultState;
		}

		default:
			return state;
	}
}

export default reducer;
